import { type FC } from "react";

import { useFeatureGates } from "../../../../cof-feature-gates/hooks";
import { CofConfigId, SurfaceType } from "../../../../gql-generated/types";
import { lensSurfaceTypeMap } from "../../../../lens/state/lensSurfaceTypeMap";

import { LensRowBadge } from "./LensRowBadge";
import { badgeSpectacles } from "./LensRowBadge.styles";

interface LensSurfaceTypeTagProps {
    surfaceType: readonly SurfaceType[];
}

export const LensSurfaceTypeTag: FC<LensSurfaceTypeTagProps> = ({ surfaceType }) => {
    const { configs } = useFeatureGates();
    const isSpectaclesSubmissionEnabled = configs[CofConfigId.MyLensesSpectaclesSubmission].enabled;
    const spectaclesSurfaceType = SurfaceType.SurfaceTypeSpectacles;
    if (!surfaceType.includes(spectaclesSurfaceType) || !isSpectaclesSubmissionEnabled) {
        return null;
    }
    return (
        <LensRowBadge dataTestId="lens-row-surface-type-badge" className={badgeSpectacles}>
            {lensSurfaceTypeMap[spectaclesSurfaceType].name}
        </LensRowBadge>
    );
};
